


























































































































































































































































































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import OrderRefundApi from '@/api/order/refund/newIndex'
import ShippingCompany from '@/api/shipping/index'
import { UpdateRefundApplyDto, ShippingAddressDto } from '@/api/order/refund/newIndex'
import areaList from '@/lib/area'

@Component({
  components: {},
})
export default class NewRefundDetail extends AbpBase {
  viewImgModal: boolean = false
  viewImgIndex: number = 0
  refundDetail: any = {}
  columns = [
    {
      title: '商品图片',
      slot: 'picture',
      align: 'center',
    },
    {
      title: '商品名称',
      key: 'productName',
      align: 'center',
    },
    {
      title: '价格/货号',
      slot: 'price',
      align: 'center',
    },
    {
      title: '属性',
      key: 'skuName',
      align: 'center',
    },
    {
      title: '数量',
      key: 'quantity',
      align: 'center',
    },
    {
      title: '小计',
      slot: 'subTotal',
      align: 'center',
    },
  ]
  areaList = areaList
  buttonLoading = false
  shippingAddress: any = {
    name: null,
    phone: null,
    province: null,
    city: null,
    district: null,
    address: null,
    zipCode: null,
    area: [],
  }
  remark = null
  refundApply = {
    expressCompanyName: null,
    shipmentNumber: null,
    refuseReason: null,
  }
  ruleRefundApply = {
    expressCompanyName: [{ required: true, message: '请选择快递公司', trigger: 'blur' }],
    shipmentNumber: [{ required: true, message: '请输入快递单号', trigger: 'blur' }],
    refuseReason: [{ required: true, message: '请输入退款原因', trigger: 'blur' }],
  }
  shipmentList: any[] = []

  noteColumns = [
    {
      title: '处理账号',
      key: 'userName',
      align: 'center',
    },
    {
      title: '退款状态',
      key: 'applyStatus',
      align: 'center',
    },
    {
      title: '操作时间',
      slot: 'creationTime',
      align: 'center',
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
    },
  ]

  noteTableData = []
  writeShipment = {
    expressCompanyName: null,
    shipmentNumber: null,
    expressCompanyCode: null,
  }
  currentExpressCompany = null
  showWriteShipmentModal: Boolean = false
  ruleWriteShipment = {
    expressCompanyName: [{ required: true, message: '请选择快递公司', trigger: 'blur' }],
    shipmentNumber: [{ required: true, message: '请输入快递单号', trigger: 'blur' }],
  }

  @Watch('refundDetail.isReturnShippingFee')
  isReturnShippingFeeChange(value) {
    if (value) {
      if (this.refundDetail.applyStatus === 0) {
        this.refundDetail.refundAmount = this.getTotalNum(
          this.refundDetail.expectedRefundAmount,
          this.refundDetail.shippingFee
        )
      } else {
        this.refundDetail.refundAmount = this.getTotalNum(
          this.refundDetail.refundAmount,
          0
          // this.refundDetail.shippingFee
        )
      }
    } else {
      if (this.refundDetail.applyStatus === 0) {
        this.refundDetail.refundAmount = this.refundDetail.expectedRefundAmount
      } else {
        this.refundDetail.refundAmount = this.refundDetail.refundAmount
      }
    }
  }

  // 退款商品
  get orderFoods() {
    return this.refundDetail.refundOrderItems
  }

  /**
   * 凭证照片
   */
  get orderRefundImg() {
    let list = []
    if (this.refundDetail.attachment) {
      list = this.refundDetail.attachment.split(',')
    }
    return list
  }

  mounted() {
    this.getShippingCompanyList()
    this.getRefundDetail()
  }

  viewImg(index) {
    this.viewImgIndex = index
    this.viewImgModal = true
  }
  returnShippingFeeOnChange(e) {
    // console.log(e);
    // if(!this.refundDetail.isReturned) {
    //   this.$Notice.success({ desc: '您已退过运费了！' })
    //   return
    // }
    if (e) {
      if (this.refundDetail.applyStatus === 0) {
        this.refundDetail.refundAmount = this.refundDetail.expectedRefundAmount + this.refundDetail.shippingFee
      } else {
        this.refundDetail.refundAmount = this.refundDetail.refundAmount + this.refundDetail.shippingFee
      }
    } else {
      if (this.refundDetail.applyStatus === 0) {
        this.refundDetail.refundAmount = this.refundDetail.expectedRefundAmount
      } else {
        this.refundDetail.refundAmount = this.refundDetail.refundAmount
      }
    }
  }
  getTotalNum(num1, num2) {
    if (!num1) {
      num1 = 0
    }
    if (!num2) {
      num2 = 0
    }
    return (num1 * 100 + num2 * 100) / 100
  }
  /**
   * 获取物流公司列表
   */
  getShippingCompanyList() {
    ShippingCompany.getShippingCompanyList().then((res) => {
      this.shipmentList = res.data.items
    })
  }

  getRefundDetail() {
    let vm = this
    let id = vm.$route.query['id'].toString()
    vm.remark = null
    vm.getRefundNoteList()
    OrderRefundApi.getRefundDetail(id).then((res) => {
      console.log('退款订单详情', res)
      vm.refundDetail = res.data
      if (vm.refundDetail.refundShippingAddress) {
        vm.shippingAddress = vm.refundDetail.refundShippingAddress
        vm.shippingAddress['area'] = []
        if (vm.refundDetail.refundShippingAddress.province) {
          vm.shippingAddress.area[0] = vm.refundDetail.refundShippingAddress.province
        }
        if (vm.refundDetail.refundShippingAddress.city) {
          vm.shippingAddress.area[1] = vm.refundDetail.refundShippingAddress.city
        }
        if (vm.refundDetail.refundShippingAddress.district) {
          vm.shippingAddress.area[2] = vm.refundDetail.refundShippingAddress.district
        }
      }
      if (vm.refundDetail.expectedRefundAmount) {
        if (this.refundDetail.applyStatus === 0) {
          vm.refundDetail.refundAmount = vm.refundDetail.expectedRefundAmount
        } else {
          vm.refundDetail.refundAmount = vm.refundDetail.refundAmount
        }
      }
    })
  }

  /**
   * 获取退款操作记录
   */
  getRefundNoteList() {
    let id = this.$route.query['id'].toString()
    OrderRefundApi.getRefundNoteList(id).then((res) => {
      this.noteTableData = res.data.items
    })
  }

  statusString(status) {
    let text = status
    switch (status) {
      case 0:
        text = '待处理'
        break
      case 1:
        text = '处理中'
        break
      case 2:
        text = '已完成'
        break
      case 3:
        text = '已拒绝'
        break
      case 4:
        text = '已取消'
        break
      default:
        text = status
        break
    }
    return text
  }

  /**
   * 同意/拒绝退款申请 汇总
   */
  agreeRefundApply(type) {
    const reg = /^[1][3-8]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/
    let { refundDetail, shippingAddress, remark } = this
    if (refundDetail.refundAmount == null) {
      this.$Modal.error({
        title: '请输入确认退款金额',
      })
      return
    }
    // refundType 0 退款 1 退款退货
    if (refundDetail.refundType == 1) {
      if (!shippingAddress.name) {
        this.$Modal.error({
          title: '请输入收货人姓名',
        })
        return
      }
      if (!shippingAddress.phone || !reg.test(shippingAddress.phone)) {
        this.$Modal.error({
          title: '请输入正确的收货人手机号码',
        })
        return
      }
      if (shippingAddress.area.length == 0) {
        this.$Modal.error({
          title: '请选择所在区域',
        })
        return
      }
      if (!shippingAddress.address) {
        this.$Modal.error({
          title: '请输入详细地址',
        })
        return
      }
    }
    this.buttonLoading = true
    let id = this.$route.query['id'].toString()
    let obj = new UpdateRefundApplyDto()
    obj.isReturnShippingFee = refundDetail.isReturnShippingFee
    obj.refundAmount = refundDetail.refundAmount
    obj.remark = remark
    // obj.applyStatus = refundDetail.refundType == 1 ? 1 : 2;
    obj.auditResult = type == 'agree' ? true : false

    if (refundDetail.refundType == 1) {
      obj.shippingAddress = new ShippingAddressDto()
      obj.shippingAddress.name = shippingAddress.name
      obj.shippingAddress.phone = shippingAddress.phone
      obj.shippingAddress.address = shippingAddress.address

      obj.shippingAddress.province = shippingAddress.area[0]
      obj.shippingAddress.city = shippingAddress.area[1]
      obj.shippingAddress.district = shippingAddress.area[2]
    }
    if (type == 'refuse') {
      if (!this.remark) {
        this.$Modal.error({
          title: '请输入处理备注',
        })
        this.buttonLoading = false
        return
      }
      this.$Modal.confirm({
        title: '提示',
        content: `确认拒绝申请?`,
        onOk: () => {
          OrderRefundApi.updateRefundapply(id, obj)
            .then((res) => {
              this.buttonLoading = false
              this.getRefundDetail()
            })
            .catch((err) => {
              this.buttonLoading = false
            })
        },
      })
    } else {
      OrderRefundApi.updateRefundapply(id, obj)
        .then((res) => {
          this.buttonLoading = false
          this.getRefundDetail()
        })
        .catch((err) => {
          this.buttonLoading = false
        })
    }
  }
  /**
   * 确认收货
   */
  receivedRefund() {
    let id = this.$route.query['id'].toString()
    OrderRefundApi.returnReceived(id)
      .then((res) => {
        this.buttonLoading = false
        this.getRefundDetail()
      })
      .catch((err) => {
        this.buttonLoading = false
      })
  }

  /**
   * 帮填退货快递单号
   */
  writeShipmentNumber() {
    let id = this.$route.query['id'].toString()
    let form: any = this.$refs['formWriteShipment']
    let { writeShipment } = this
    form.validate((valid) => {
      if (valid) {
        // debugger;
        // console.log(id, writeShipment);
        OrderRefundApi.shipment(id, writeShipment)
          .then((res) => {
            this.buttonLoading = false
            this.cancelWriteShipment()
            this.getRefundDetail()
          })
          .catch((err) => {
            this.buttonLoading = false
          })
      }
    })
  }

  cancelWriteShipment() {
    this.showWriteShipmentModal = false
    let form: any = this.$refs['formWriteShipment']
    form.resetFields()
    this.writeShipment.expressCompanyCode = null
    this.currentExpressCompany = null
  }

  getExpressCompanyCode(e) {
    // console.log(e);
    if (e) {
      const result = this.shipmentList.filter((item) => item.id == e)[0]
      this.writeShipment.expressCompanyCode = result.code
      this.writeShipment.expressCompanyName = result.expressCompanyName
    }
  }
}
